import { Component, OnInit } from '@angular/core';
import { DropzoneConfigInterface } from 'angular2-dropzone-wrapper';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-import-department-page',
  templateUrl: './import-department-page.component.html',
  styleUrls: ['./import-department-page.component.scss']
})
export class ImportDepartmentPageComponent implements OnInit {

  constructor(private route: ActivatedRoute, private titleService: Title) { }

  config: DropzoneConfigInterface;
  edit: boolean[] = [];
  sub: any;
  orgId: number;


  departmentTemplateUrl = environment.departmentTemplateUrl;

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.config = {
        dictDefaultMessage: `<div class="text">
            <p style='color: silver'>Drag completed file here</p>
            <p style='color: silver'>or</p>
            <a style="border: 1px solid black;
              border-radius: 20px;
              background: transparent;
              color: black;
              padding: 10px 20px;                            
              font-size: 15px;
              display: inline-block">
              <b>SELECT FILE</b>
            </a>
          </div>`,
        dictFallbackMessage: '',
        server: `${environment.organizationsUrl}/${this.orgId}/departments/upload.json`,
        headers: {
          Authorization: `Bearer ${localStorage.onboardingToken}`,
        },
        maxFilesize: 2,
        acceptedFiles: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv',
        paramName: 'file'        
      }
    });

    this.titleService.setTitle('Import Departments');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }


  onUploadSuccess(e: any) {

  }

  onUploadError(e: any) {

  }

  onCancel(e: any) {

  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/import-department-page/import-department-page.component.ts